/* eslint-disable camelcase */

export type DateRangeType = "fixed" | "rolling";
export type TimeGranularity = "days" | "weeks" | "months";

export interface EngagementQueryBuilderReportResult {
  _id: string;
  report_query: string;
  results_generated: string;
  results: Array<Array<any>>;
  loading: boolean;
  failure_count: number;
  query_params: {
    api_id?: string;
    message_type?: string;
  };
  report_run_start_time: string;
  error_occurred: boolean;
  error_message: string;
  error_sql_state: string;
  edited_at: string;
  name: string;
  sql: string;
  associated_dashboards: AssociatedDashboards;
  max_lookback_days: string;
  variables?: PersistedVariable[];
  expanded_exports_enabled?: boolean;
  start_date?: number;
  end_date?: number;
  date_range_type?: DateRangeType;
  relative_date_range_granularity?: TimeGranularity;
  relative_date_range_value?: number;
}

export interface AssociatedDashboards {
  [dashboard_id: string]: AssociatedDashboard;
}

export interface AssociatedDashboard {
  dashboard_id: string;
  dashboard_name: string;
  tiles: { tile_id: string; tile_title: string; tile_data_query_id: string }[];
}

export interface PersistedVariable {
  name: string;
  value: any;
  type: TYPE;
  start_date?: string;
  end_date?: string;
  y_days?: string;
  value_name?: string;
  metadata?: Metadata;
}

export interface EditorVariable {
  name: string;
  type: TYPE;
  metadata: Metadata;
}

export type Metadata = {
  isVisible: boolean;
  isRequired: boolean;
  order?: number;
  includeQuotes?: boolean;
  includeDoubleQuotes?: boolean;
  isMultiSelect?: boolean;
  options?: Option[];
  placeholder?: string;
  description?: string;
  defaultValue?: string;
  hideLabel?: boolean;
  hideDescription?: boolean;
  isRadioButton?: boolean;
  eventNamespace?: "purchase" | "customEvent";
  label?: string;
  includeNonRetargetable?: boolean;
  useBsonId?: boolean;
  alwaysVisible?: boolean;
};

export type Option = {
  label: string;
  value: string;
};

export type EditorFormValues = Record<string, any>;

export enum TYPE {
  CAMPAIGN = "campaign",
  CAMPAIGNS = "campaigns",
  CANVAS = "canvas",
  CANVASES = "canvases",
  PRODUCTS = "products",
  CANVAS_STEP = "canvas_step",
  CANVAS_STEPS = "canvas_steps",
  CANVAS_VARIANTS = "canvas_variants",
  CAMPAIGN_VARIANTS = "campaign_variants",
  DATE_RANGE = "date_range",
  START_DATE = "start_date",
  END_DATE = "end_date",
  NUMBER = "number",
  STRING = "string",
  SEGMENTS = "segments",
  TAGS = "tags",
  CATALOGS = "catalogs",
  CATALOG_FIELDS = "catalog_fields",
  CUSTOM_EVENTS = "custom_events",
  EVENTS_PROPERTIES = "events_properties",
  OPTIONS = "options",
  WORKSPACE = "workspace",
  RADIO_BUTTON = "radio_button",
}
